import { $vfm } from 'vue-final-modal'
import SelectCategoriesModal from "../Modals/SelectCategoriesModal.vue"

export default function useSelectCategoriesModal(callback) {

  const close = () => {
    $vfm.hideAll().then(r => {})
  }

  const open = () => {
    $vfm.show({
      component: SelectCategoriesModal,
      bind: { callback, close }
    })
  }

  return {
    open,
    close
  }
}
